import React, { FC, ReactNode } from "react";
import { Box, Button, DialogActions, DialogContent, Typography } from "@mui/material";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";
import { useDialog } from "../../licensing/utils/DialogProvider";
import { Warning } from "@mui/icons-material";

const AreYouSureDialog: FC<{
  content: ReactNode | string;
  onOk: () => void;
  onCancel?: () => void;
  okLabel?: ReactNode;
}> = ({ content, onOk, onCancel, okLabel }) => {
  const [, closeDialog] = useDialog();
  return (
    <>
      <Box sx={{ display: "flex", paddingX: 6, paddingY: 4 }}>
        <Warning fontSize={"large"} color={"warning"} />
        <Typography variant={"h6"}>
          <TranslationWrapper tKey={"Are you sure?"} />
        </Typography>
      </Box>
      <DialogContent>
        <Typography style={{ fontWeight: 800, textAlign: "center" }}>{content}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color={"error"}
          onClick={() => {
            closeDialog();
            onCancel?.();
          }}
          variant={"contained"}
        >
          {okLabel ?? <TranslationWrapper tDefault={"Cancel"} tKey={"areyousure.Cancel"} />}
        </Button>
        <Button
          color={"primary"}
          onClick={() => {
            closeDialog();
            onOk();
          }}
          variant={"contained"}
        >
          {okLabel ?? <TranslationWrapper tDefault={"Ok"} tKey={"areyousure.Ok"} />}
        </Button>
      </DialogActions>
    </>
  );
};

export default AreYouSureDialog;
